// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../i18n/l10n';
import { MPLogo } from '../assets/svg';
import MPRulesButtonContainer from '../containers/MPRulesButtonContainer';

const HeaderWrapperTheme = {
  boxShadowColor: '#102f3f80',
  backgroundGradientTop: '#3B95B5',
  backgroundGradientBottom: '#22EFFF',
};

const HeaderContentTheme = {
  backgoundColor: '#08405cb3',
};

const Wrapper = styled.div`
  padding: 0.125em;
  position: relative;

  &::before {
    content: '';
    background: linear-gradient(
      ${HeaderWrapperTheme.backgroundGradientTop},
      ${HeaderWrapperTheme.backgroundGradientBottom}
    );
    border-radius: 1em;
    bottom: 0;
    box-shadow: 0 0.125em 0.6em 0 ${HeaderWrapperTheme.boxShadowColor};
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
  }
`;

const Content = styled.div`
  background-color: ${HeaderContentTheme.backgoundColor};
  border-radius: 0.9em;
  padding: 0.3em 0.6em 0.6em;
  position: relative;
  z-index: 1;
`;

const Top = styled.div`
  align-items: center;
  display: flex;
`;

const Title = styled.div`
  -webkit-text-stroke: 1px #000;
  color: #fff;
  font-family: 'KabelHasbro';
  font-weight: 700;
  font-size: 1.5em;
  text-shadow: 0 1px 0 #000;
  text-transform: uppercase;
  transform: translateY(1px);
`;

const StyledMPLogo = styled(MPLogo)`
  margin-left: 0.375em;
  stroke: white;
  stroke-width: 0.6px;
`;

const CollectedInfos = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0.375em;
  color: #fff;
  display: inline-block;
  font-family: 'KabelHasbro';
  font-weight: 300;
  font-size: 0.8em;
  line-height: 1.5em;
  padding: 0.2em 0.5em 0;
`;

type MPHeaderProps = {
  className?: string;
  userNbWonCards?: number;
  totalNbCards?: number;
};

const MPHeader = ({ className = '', userNbWonCards = 0, totalNbCards = 0 }: MPHeaderProps) => {
  return (
    <Wrapper className={className}>
      <Content>
        <Top>
          <Title>{__('My collection')}</Title>
          <StyledMPLogo />
          <MPRulesButtonContainer />
        </Top>
        <CollectedInfos>
          {__('!noun:MonopolyWon', [userNbWonCards], '!noun:MonopolyWonPlural')} {userNbWonCards} / {totalNbCards}
        </CollectedInfos>
      </Content>
    </Wrapper>
  );
};

export default MPHeader;
